import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

export default function updateSubTestResult(payload) {
	return fetch(
		`${ENDPOINT_URL}/updatesubtestresult`,
		getFetchOptions({
			method: 'PUT',
			body: JSON.stringify(payload),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
